export default __webpack_public_path__ + "static/media/Stainless Steel Pipe Line work.487c66e5.jpg";